import { memo } from "react"
import { personalInfo } from "@/config/personal"
import { useDocumentTitle } from "@/hooks/useDocumentTitle"
import { BackLink } from "@/components/BackLink"

/**
 * 404 Not Found page component.
 * Displayed when users navigate to a route that doesn't exist.
 */
export const NotFound = memo(function NotFound() {
  useDocumentTitle(`Page not found - ${personalInfo.name}`)

  return (
    <div className="flex flex-col items-center py-12 text-center sm:py-16">
      <h1 className="mb-4 text-6xl font-bold">404</h1>
      <p className="mb-8 text-xl text-fg-muted">Page not found</p>
      <p className="mb-8 max-w-md text-fg-subtle">
        The page you’re looking for doesn’t exist or has been moved.
      </p>
      <BackLink />
    </div>
  )
})

NotFound.displayName = "NotFound"

export default NotFound
